export const ManaMark = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <rect x="0.5" y="0.5" width="31" height="31" rx="7.5" stroke="rgba(255,255,255,0.14)" fill="#0B0B10" />
    <path d="M7 23V10.5l9 7 9-7V23" stroke="#D4FF3A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="16" cy="9" r="1.8" fill="#D4FF3A" />
  </svg>
);

export const ManaWordmark = ({ compact = false }) => (
  <div className="flex items-center gap-2.5 min-w-0" data-testid="brand-wordmark">
    <ManaMark size={compact ? 26 : 30} />
    <div className="leading-none min-w-0">
      <div className="font-display text-[22px] tracking-tight text-foreground truncate">Manahouse</div>
      {!compact && <div className="font-mono text-[9px] uppercase tracking-[0.28em] text-muted-foreground mt-1">AI workforce command</div>}
    </div>
  </div>
);
